import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import { CenterContent } from 'components/Layout'

export const SkewedContent = styled(CenterContent)`
	width: 100%;
	height: 100%;
	padding: 16vh 84px 84px;
	text-align: center;
	margin: 0;

	${mobileMediaQuery(css`
		padding: 64px 32px 32px;
	`)}
`
